import { type IHeaderGroupParams } from "ag-grid-community";
import { type FC, useMemo } from "react";

import { HStack } from "widgets";

import style from "../../styles/GridHeader.module.scss";

import { CELL_EXPANSION } from "../../../../../settings/settings.js";
import { type ICustomColDef } from "../../DataTable.js";
import { type IGridContextProps } from "../../InMemoryTableWithSelectionModel.js";
import { ExpansionIconCell } from "./HeaderCell.js";

export interface IHeaderGroupCellProps {}

const HeaderGroupCell: FC<IHeaderGroupCellProps & IHeaderGroupParams> = (props) => {
  const { displayName } = props;
  const context: IGridContextProps = props.context;

  const expandableColumnGroupField: string = useMemo<string>(() => {
    if (!context?.tableSpec) {
      return null;
    }
    const firstExpandableColumn: ICustomColDef = props.columnGroup
      .getLeafColumns()
      .map((column) => column.getUserProvidedColDef())
      .find((column: ICustomColDef) => column.cellExpansion === CELL_EXPANSION.GROUP);

    return firstExpandableColumn?.groupField;
  }, []);

  return (
    <HStack className={style.group_header}>
      <div className={style.group_header_title}>{displayName}</div>
      {expandableColumnGroupField && (
        <ExpansionIconCell tableQuerySpec={context?.tableSpec} expandableField={expandableColumnGroupField} />
      )}
    </HStack>
  );
};

export default HeaderGroupCell;
